import { Card, CardContent } from "@/components/ui/card";
import { Lock } from "lucide-react";

export const RestrictedAccess = () => (
  <div className="flex items-center justify-center min-h-[400px]">
    <Card className="max-w-md">
      <CardContent className="pt-6">
        <div className="flex flex-col items-center text-center">
          <Lock className="h-12 w-12 text-yellow-500 mb-4" />
          <h3 className="text-lg font-semibold mb-2">Acceso Restringido</h3>
          <p className="text-muted-foreground">
            No tienes permisos para acceder a este módulo.
          </p>
        </div>
      </CardContent>
    </Card>
  </div>
)